import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


/**
 * 审核管道
 *  @example <td [innerHTML]="data.state | auditState"></td>
 */
@Pipe({
  name: 'auditState'
})
export class AuditStatePipe implements PipeTransform {


  //获取当前dom节点
  constructor(private dom: DomSanitizer) { }

  /**
   * 管道的初始化方法
   * 
   * 0：<span style="cursor:pointer"  class="state-error">未提交</span>
   * 
   * 1：<span style="cursor:pointer"  class="state-info">审核中</span>
   * 
   * 2：<span style="cursor:pointer"  class="state-success">已通过</span>
   * 
   * 3：<span style="cursor:pointer"  class="state-waring">已驳回</span>
   * 
   * 4:<span style="cursor:pointer"  class="state-error">退回重审</span>
   * 
   * 5:<span style="cursor:pointer"  class="state-error">已撤销</span>
   */
  /**
   * 将状态值转化为中文且提供样式
   * @param value 流程状态
   * @param type 样式类型，不传默认为1,
   */
  transform(value: number | string,type?:number): any {
    if(value || value == 0 || value == '0'){
      value = parseInt(value.toString())
      if(!type || type == 1){
        switch (value){
          case 0:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">未提交</span>`); 
          case 1:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info">审核中</span>`); 
          case 2:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-success">已通过</span>`);
          case 3:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-waring">已退回</span>`);
          case 4:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">已拒绝</span>`); 
          case 5:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error">已撤销</span>`);   
        }
      } else if(type == 2){
        switch (value){
          case 0:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error-type2">未提交</span>`); 
          case 1:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-info-type2">审核中</span>`); 
          case 2:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-success-type2">已通过</span>`);
          case 3:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-waring-type2">已退回</span>`);
          case 4:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error-type2">已拒绝</span>`); 
          case 5:  return this.dom.bypassSecurityTrustHtml(` <span style="cursor:pointer"  class="state-error-type2">已撤销</span>`);   
        }
      }
    }
  }
}
